import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b483a46a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"margin-top":"-3rem"},
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer p-9" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fw-bolder m-0 mx-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_8 = { class: "card-body p-9" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download fs-4 me-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Pitch Deck")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "About")
], -1))
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Name", -1))
const _hoisted_16 = { class: "col-lg-8" }
const _hoisted_17 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_18 = { class: "row mb-7" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Summary", -1))
const _hoisted_20 = { class: "col-lg-8 fv-row" }
const _hoisted_21 = { class: "fw-bold fs-6" }
const _hoisted_22 = { class: "row mb-7" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Overview ", -1))
const _hoisted_24 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_25 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "USP", -1))
const _hoisted_28 = { class: "col-lg-8" }
const _hoisted_29 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Geo Base ", -1))
const _hoisted_32 = { class: "col-lg-8" }
const _hoisted_33 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_34 = { class: "row mb-7" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "The Team Members", -1))
const _hoisted_36 = { class: "col-lg-8" }
const _hoisted_37 = { class: "fw-bolder fs-6 text-dark float-right" }
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_40 = { class: "card-body p-9" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Contact Details")
], -1))
const _hoisted_42 = { class: "row mb-7" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Telephone", -1))
const _hoisted_44 = { class: "col-lg-8" }
const _hoisted_45 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_46 = { class: "row mb-7" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Website", -1))
const _hoisted_48 = { class: "col-lg-8" }
const _hoisted_49 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_50 = { class: "row mb-7" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Advanced Assurance", -1))
const _hoisted_52 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_53 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_54 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_55 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_56 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_57 = {
  key: 1,
  class: "col-lg-8"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "None", -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "row mb-7" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Stage of Evolution", -1))
const _hoisted_62 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_63 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_64 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_65 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_66 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_67 = {
  key: 1,
  class: "col-lg-8"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "None", -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "row mb-7" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Minimum Traction", -1))
const _hoisted_72 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_73 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_74 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_75 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_76 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_77 = {
  key: 1,
  class: "col-lg-8"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "None", -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_81 = { class: "card-body p-9" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Industry Sectors")
], -1))
const _hoisted_83 = { class: "row mb-7" }
const _hoisted_84 = { class: "col-lg-8" }
const _hoisted_85 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_86 = { class: "card-header" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Funding Rounds", -1))
const _hoisted_88 = { class: "card-toolbar" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("New")
const _hoisted_90 = { class: "card-body pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FundingRounds = _resolveComponent("FundingRounds")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              style: {"object-fit":"cover"},
              src: _ctx.business.logo ?? require('@/assets/img/blank.png'),
              alt: "image"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.business.name), 1)
        ]),
        _createVNode(_component_router_link, {
          to: `/update-investment-opportunity/${_ctx.route.params.id}`,
          class: "btn btn-primary align-self-center mx-md-5 res-width"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.business.pitchDeckDocument)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              download: "",
              href: _ctx.business.pitchDeckDocument,
              class: "btn btn-primary my-3 res-width2"
            }, _hoisted_12, 8, _hoisted_9))
          : _createCommentVNode("", true),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.business.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.business.summary), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.business.overview), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.business.defensibleUsp), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.toUpperCase(_ctx.business.geoFocusCountryCode)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.business?.teamMembers ?? [], (member, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `team-member-${index}`
              }, [
                _createElementVNode("span", _hoisted_37, [
                  _createTextVNode(_toDisplayString(member.name) + " (" + _toDisplayString(member.jobTitle) + ") ", 1),
                  _createElementVNode("a", {
                    href: member.linkedInProfileUrl,
                    target: "_blank"
                  }, "LinkedIn Profile", 8, _hoisted_38)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.business.telephone), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.business.website), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          (
              _ctx.business.advanceAssuranceSeis == 1 ||
              _ctx.business.advanceAssuranceEis == 1 ||
              _ctx.business.advanceAssuranceAppliedFor == 1 ||
              _ctx.business.advanceAssuranceNotApplicable == 1
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.business.advanceAssuranceSeis == 1 ? `SEIS${(_ctx.business.advanceAssuranceEis == 1 ||
              _ctx.business.advanceAssuranceAppliedFor == 1 ||
              _ctx.business.advanceAssuranceNotApplicable == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.business.advanceAssuranceEis == 1 ? `EIS${(
              _ctx.business.advanceAssuranceAppliedFor == 1 ||
              _ctx.business.advanceAssuranceNotApplicable == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.business.advanceAssuranceAppliedFor == 1 ? `Applied For${(
              _ctx.business.advanceAssuranceNotApplicable == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.business.advanceAssuranceNotApplicable == 1 ? 'Not Applicable' : ''), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          (
              _ctx.business.stageOfEvolutionPreSeed == 1 ||
              _ctx.business.stageOfEvolutionSeed == 1 ||
              _ctx.business.stageOfEvolutionPreSeriesA == 1 ||
              _ctx.business.stageOfEvolutionSeriesA == 1
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.business.stageOfEvolutionPreSeed == 1 ? `Pre-seed${(_ctx.business.stageOfEvolutionSeed == 1 ||
              _ctx.business.stageOfEvolutionPreSeriesA == 1 ||
              _ctx.business.stageOfEvolutionSeriesA == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.business.stageOfEvolutionSeed == 1 ? `Seed${(
              _ctx.business.stageOfEvolutionPreSeriesA == 1 ||
              _ctx.business.stageOfEvolutionSeriesA == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.business.stageOfEvolutionPreSeriesA == 1 ? `Pre-series A${(
              _ctx.business.stageOfEvolutionSeriesA == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.business.stageOfEvolutionSeriesA == 1 ? 'Series A' : ''), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_69))
        ]),
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          (
              _ctx.business.minimumTractionPreMvp == 1 ||
              _ctx.business.minimumTractionPostMvp == 1 ||
              _ctx.business.minimumTractionPreRevenue == 1 ||
              _ctx.business.minimumTractionPostRevenue== 1
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.business.minimumTractionPreMvp == 1 ? `Pre-MVP${(_ctx.business.minimumTractionPostMvp == 1 ||
              _ctx.business.minimumTractionPreRevenue == 1 ||
              _ctx.business.minimumTractionPostRevenue == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.business.minimumTractionPostMvp == 1 ? `Post-MVP${(
              _ctx.business.minimumTractionPreRevenue == 1 ||
              _ctx.business.minimumTractionPostRevenue == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.business.minimumTractionPreRevenue == 1 ? `Pre-Revenue${(
              _ctx.business.minimumTractionPostRevenue == 1) ? ', ' : ''}` : ''), 1),
                _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.business.minimumTractionPostRevenue == 1 ? 'Post-Revenue' : ''), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_79))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _hoisted_82,
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.business.industrySectors, (sector) => {
              return (_openBlock(), _createElementBlock("span", {
                key: sector.id,
                class: "badge badge-light-primary me-2"
              }, _toDisplayString(sector.name), 1))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_85, [
      _createElementVNode("div", _hoisted_86, [
        _hoisted_87,
        _createElementVNode("div", _hoisted_88, [
          _createVNode(_component_router_link, {
            to: `/create-funding-round?businessId=${_ctx.business.id}`,
            type: "button",
            class: "btn btn-sm btn-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_89
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("div", _hoisted_90, [
        _createVNode(_component_FundingRounds, {
          businessId: _ctx.business.id
        }, null, 8, ["businessId"])
      ])
    ])
  ]))
}